import LegalShell, { LegalSection } from "@/components/LegalShell";
import { CONTACT } from "@/lib/site";

export default function MentionsLegales() {
  return (
    <LegalShell testid="mentions" title="Mentions légales">
      <LegalSection n="01" title="Éditeur du site">
        <p>
          Le site maxrevix.fr est édité et exploité par <strong className="text-white">MAXREVIX — Maxime Cros</strong>, entrepreneur individuel
          (micro-entreprise) : réparation, rachat et reconditionnement de smartphones, tablettes et ordinateurs.
        </p>
        <p>Atelier : 74800 Saint-Pierre-en-Faucigny, France</p>
        <p>
          Contact : <a className="font-semibold text-neon hover:underline" href={CONTACT.phoneHref}>{CONTACT.phoneDisplay}</a> ·{" "}
          <a className="font-semibold text-neon hover:underline" href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
          <br />
          Du lundi au vendredi, 09h00 – 19h00
        </p>
        <p>SIRET : [SIRET à compléter]</p>
        <p>TVA : TVA non applicable, article 293 B du CGI (micro-entreprise).</p>
        <p>Directeur de la publication : Maxime Cros.</p>
      </LegalSection>

      <LegalSection n="02" title="Hébergement">
        <p>Ce site est hébergé sur la plateforme cloud Emergent (emergentagent.com). Le nom de domaine maxrevix.fr est configuré par l'éditeur.</p>
      </LegalSection>

      <LegalSection n="03" title="Propriété intellectuelle">
        <p>
          L'ensemble des contenus du site (textes, structure, logo, visuels, signature « Repair. Renew. Repeat. ») est la propriété exclusive de
          MAXREVIX, sauf mention contraire. Toute reproduction, représentation ou adaptation, totale ou partielle, sans autorisation écrite
          préalable est interdite et constitue une contrefaçon.
        </p>
        <p>
          Les marques et modèles d'appareils (Apple, iPhone, Samsung, Google, Xiaomi, etc.) cités appartiennent à leurs propriétaires respectifs
          et sont mentionnés uniquement pour identifier les appareils pris en charge. MAXREVIX est un atelier indépendant, sans affiliation avec
          ces marques.
        </p>
      </LegalSection>

      <LegalSection n="04" title="Données personnelles & cookies">
        <p>
          Les données transmises via le formulaire de devis (nom, téléphone, email, informations sur l'appareil) et via l'espace client (email,
          nom, photo de profil en cas de connexion Google) sont utilisées uniquement pour traiter vos demandes, assurer le suivi des réparations
          et vous notifier l'avancement de vos dossiers.
        </p>
        <p>
          Elles ne sont ni vendues, ni louées, ni transmises à des tiers à des fins commerciales. Vous disposez d'un droit d'accès, de
          rectification et d'effacement de vos données, que vous pouvez exercer par email à{" "}
          <a className="font-semibold text-neon hover:underline" href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>.
        </p>
        <p>
          Le site utilise uniquement un cookie de session strictement nécessaire (espace client, 7 jours) ; aucun traceur publicitaire ni cookie
          tiers de mesure d'audience n'est déposé.
        </p>
      </LegalSection>

      <LegalSection n="05" title="Réclamations & médiation">
        <p>
          Pour toute réclamation, contactez-nous en priorité par email ou téléphone : nous cherchons ensemble une solution rapide. Le client
          consommateur peut, à défaut de résolution amiable, recourir gratuitement au médiateur de la consommation dont relève MAXREVIX
          (article L612-1 du code de la consommation) — coordonnées du médiateur : [à compléter].
        </p>
      </LegalSection>
    </LegalShell>
  );
}
